<template>
    <div class="header__container" v-if="isVisibleHeaderTitle">
        <img style="width: 1.5rem; height: 1.5rem" src="../../../public/images/arrow-back.svg" @click="previousPage"/>
        <span class="header__container__title"> {{ titleName  }} </span>
    </div>
</template>

<script>
import { useRouter } from 'vue-router'
    export default {
        props: {
            titleName: {
                type: String,
                required: true
            },
            isVisibleHeaderTitle: {
                type: Boolean,
                default: true
            }
        },
        setup(props, {emit}) {
            const title = props.titleName
            const router = useRouter();

            const previousPage = () => {
                router.back();
            }
            return {
                title: title,
                previousPage
            };
        }
    }
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .header__container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 1.5rem;
        width: 100%;
        gap: 1.5em;
    }

    .header__container__title {
        color: $color-card-dark;
        font-size: 20px;
        font-weight: 500;
    }
</style>
